import {Box} from '@mantine/core';
import type {PropsWithChildren} from 'react';
import {useIsAppWebView} from '../../hooks/useIsAppWebView';
import {GeneralFooter} from '../Footer/general';
import {GeneralHeaderContainer} from '../Header/General/container';

export const NoLeftSidebarLayout = ({children}: PropsWithChildren) => {
  const isWebView = useIsAppWebView();
  return (
    <>
      <div>
        {!isWebView && <GeneralHeaderContainer />}
        <main>
          <Box className="flex min-h-screen flex-col items-center bg-background-1 py-12 pc:py-32">
            {children}
          </Box>
        </main>
        {!isWebView && <GeneralFooter />}
      </div>
    </>
  );
};
